<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">NADZORNA PLOČA</h2>

  <div class="customTable nadzornaPloca m-40">
    <div id="data-grid-demo">
      <dx-data-grid
        id="gridContainer"
        [dataSource]="tablica"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        keyExpr="sifra"
        [showColumnLines]="true"
        [showBorders]="false"
        [columnAutoWidth]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'">
          <div class="naslov">
            <h2 class="mb-0">Trenutna proizvodnja po linijama</h2>
            <p class="mt-0">Praćenje trenutne proizvodnje po linijama</p>
          </div>
        </div>

        <!-- Promjena datuma -->
        <div *dxTemplate="let data of 'odabirDatuma'">
          <div class="nadzornaDatum">
            <span>Datum</span>
            <dx-date-box
              pickerType="calendar"
              placeholder="Odaberite datum"
              [value]="today"
              displayFormat='dd.MM.yyyy.'
              (onValueChanged)="promjenaDatuma($event)"
            >
            </dx-date-box>
          </div>
        </div>

        <!-- Promjena smjene -->
        <div *dxTemplate="let data of 'odabirSmjene'">
          <div class="selectDropdown">
            <span>Smjena</span>
            <dx-select-box
              [disabled]="false"
              [items]="smjene"
              [value]="smjene[0].id"
              valueExpr="id"
              displayExpr="naziv"
              [width]="120"
              (onValueChanged)="promjenaSmjene($event)"
            >
            </dx-select-box>
          </div>
        </div>

        <!-- Promjena linije -->
        <div *dxTemplate="let data of 'odabirLinije'">
          <div class="selectDropdown">
            <span>Linija</span>
            <dx-select-box
              [disabled]="false"
              [items]="linije"
              [value]="linije[0].id"
              valueExpr="id"
              displayExpr="naziv"
              [width]="250"
              (onValueChanged)="promjenaLinije($event)"
            >
            </dx-select-box>
          </div>
        </div>

        <!-- <dxo-search-panel 
                [visible]="true" 
                [width]="240" 
                placeholder="Pretraži...">
            </dxo-search-panel> -->

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          caption="Broj naloga"
          [width]="100"
          alignment="center"
          cellTemplate="kreirajRN"
        >
          <div *dxTemplate="let data of 'kreirajRN'">
            <span *ngIf="data.data.statusRN">{{ data.data.brojNaloga }}</span>
            <dx-button
              *ngIf="!data.data.statusRN"
              icon="pinright"
              hint="Kreiraj radni nalog"
              (onClick)="popupKreirajRN(data)"
            >
            </dx-button>
          </div>
        </dxi-column>
        <dxi-column
          dataField="lot"
          caption="LOT"
          [width]="100"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          dataField="sifra"
          caption="Šifra"
          [width]="100"
          alignment="center"
        >
        </dxi-column>
        <dxi-column dataField="naziv" caption="Proizvod"></dxi-column>
        <dxi-column
          dataField="trebaNapraviti"
          caption="Treba napraviti"
          [width]="100"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          dataField="ispeceno"
          caption="Ispečeno"
          [width]="100"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          dataField="spakirano"
          caption="Spakirano"
          [width]="100"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          dataField="vrijemePocetka"
          caption="Vrijeme početka"
          [width]="125"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          dataField="statusRN"
          caption="Status RN"
          [width]="80"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          dataField="smjena"
          caption="Smjena"
          [width]="80"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          dataField="linija"
          caption="Linija"
          [width]="250"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          dataField="idPlan"
          caption="Plan"
          [width]="100"
          alignment="center"
        >
        </dxi-column>
        <dxi-column
          [width]="70"
          alignment="center"
          [fixed]="true"
          fixedPosition="right"
          cellTemplate="planskaKalkulacija"
        >
          <div *dxTemplate="let data of 'planskaKalkulacija'">
            <dx-button
              icon="money"
              hint="Planska kalkulacija"
              (onClick)="onPlanskaKalkulacija(data)"
            >
            </dx-button>
          </div>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>

  <dx-popup
    [width]="400"
    [height]="'auto'"
    [showTitle]="true"
    title="Kreiraj radni nalog!"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 150' }"
    [(visible)]="rnPopup"
  >
    <!-- <p>
    Izrada RN kroz web aplikaciju je u izradi i biti će dostavljeno u sljedećoj
    verziji.
  </p> -->
    <div class="floating-placeholder" style="margin-top: 20px">
      <dx-date-box
        pickerType="calendar"
        displayFormat='dd.MM.yyyy.'
        placeholder="Odaberite datum"
        [value]="today"
        (onValueChanged)="promjenaDatumaRN($event)"
      >
      </dx-date-box>
    </div>
    <div class="floating-placeholder" style="margin-top: 20px">
      <dx-text-box
        placeholder="Skladište sirovina"
        [value]="skladisteSirovina"
        [disabled]="true"
      >
      </dx-text-box>
    </div>
    <div class="floating-placeholder" style="margin-top: 20px">
      <dx-text-box
        placeholder="Skladište sirovina"
        [value]="skladisteGotovih"
        [disabled]="true"
      >
      </dx-text-box>
    </div>
    <div class="floating-placeholder" style="margin-top: 20px">
      <dx-text-area
        class="mb-20"
        placeholder="Napomena"
        [value]="napomenaRN"
        (onValueChanged)="promjenaNapomenaRN($event)"
        [disabled]="true"
      >
      </dx-text-area>
    </div>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="normal"
      text="Odustani"
      (onClick)="rnPopup = false"
    >
    </dx-button>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="KREIRAJ"
      (onClick)="kreirajRN()"
    >
    </dx-button>
  </dx-popup>
</div>
